import { createTheme, Palette } from '@mui/material';

/**
 * Scoped MUI theme for the guest table. The shared gameplay components pick
 * colours from the theme (e.g. RoundedTable uses grey[400]/secondary.light in
 * light mode, PaperCard is near-white in light mode). "light" mode therefore
 * gives ivory cards on a felt table; paper/background are kept dark so text
 * defaults (ivory) stay legible on every surface.
 */
export const sundayTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#F5A524',
      light: '#FFC35C',
      dark: '#C77F00',
      contrastText: '#1B1206',
    },
    secondary: {
      main: '#FF8466',
      // felt — used by the shared RoundedTable in light mode
      light: '#174A39',
      dark: '#B4321C',
      contrastText: '#0B1512',
    },
    error: { main: '#C22F37', contrastText: '#fff' },
    // the "whose turn" ring on avatars uses warning.main
    warning: { main: '#F5A524', contrastText: '#1B1206' },
    success: { main: '#8AD9A0', contrastText: '#0B1512' },
    info: { main: '#F7F0E1', contrastText: '#0B1512' },
    background: { default: '#0E2E24', paper: '#13201B' },
    text: {
      primary: '#F7F0E1',
      secondary: '#BCCBBF',
      disabled: '#7E8F84',
    },
    divider: 'rgba(247, 240, 225, 0.16)',
    grey: {
      50: '#FBF7EE',
      100: '#F7F0E1',
      200: '#EBE1CB',
      300: '#BCCBBF',
      // felt edge — RoundedTable border in light mode
      400: '#245A46',
      500: '#3B5A4C',
      600: '#2A4237',
      700: '#13201B',
      800: '#0E1A15',
      // black suit colour on cards
      900: '#17130F',
      A100: '#F7F0E1',
      A200: '#EBE1CB',
      A400: '#245A46',
      A700: '#13201B',
    } as Palette['grey'],
  },
  typography: {
    fontFamily: '"Space Grotesk", ui-sans-serif, system-ui, sans-serif',
  },
  shape: { borderRadius: 14 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 44,
          borderRadius: 999,
          fontWeight: 700,
          textTransform: 'none',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#0B1512',
          color: '#F7F0E1',
          fontSize: '0.85rem',
        },
        arrow: { color: '#0B1512' },
      },
    },
  },
});
